import { useWatch } from 'react-hook-form';
import { BaseOption } from 'components/forms/multiSelectField/MultiSelectField.types';
import { Trigger } from 'models/automation/Triggers';

const useSearchedTrigger = (): string | undefined => {
  const searchedTrigger: Trigger[] | BaseOption[] | undefined = useWatch({
    name: 'triggerSearch',
  });

  if (!searchedTrigger?.length) {
    return undefined;
  }

  const [chosenTrigger] = searchedTrigger;

  return 'label' in chosenTrigger ? chosenTrigger.label : chosenTrigger.name;
};

export default useSearchedTrigger;
